document.addEventListener('DOMContentLoaded', () => {
  // tarti-tabs
  // tarti-tabs__header
  //    button button button
  // tarti-tabs__body
  //    .tarti-tabs__tab .tarti-tabs__tab .tarti-tabs__tab
  const tarti_tabs = document.querySelectorAll('.tarti-tabs');
  tarti_tabs.forEach((tarti_tab) => {
    const tabs_header = tarti_tab.querySelector('.tarti-tabs__header');
    const tabs_body = tarti_tab.querySelector('.tarti-tabs__body');
    const tabs = tabs_body.querySelectorAll('.tarti-tabs__tab');
    const buttons = tabs_header.querySelectorAll('button');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if(button.classList.contains('active')) {
          return;
        }
        button.classList.add('active');
        buttons.forEach((b) => {
          if(b.dataset.tab === button.dataset.tab) return;
          b.classList.remove('active');
        });
        const tab = document.getElementById(button.dataset.tab);
        tab.classList.remove('d-none');
        tabs.forEach((t) => {
          if(t.id !== button.dataset.tab) {
            t.classList.add('d-none');
          }
        });

        const tabEvent = new CustomEvent(button.dataset.tab);
        tarti_tab.dispatchEvent(tabEvent);
      })
    });
  })
});